module.exports = __webpack_public_path__ + "img/1553614935.2295e4f9.jpg";